import { useState } from 'react';
import { faqData } from '../content/faqContent';
import { ChevronDown, ChevronUp } from 'lucide-react';

function FAQ() {
    const [openItems, setOpenItems] = useState(new Set());

    const toggleItem = (id) => {
        const newOpenItems = new Set(openItems);
        if (newOpenItems.has(id)) {
            newOpenItems.delete(id);
        } else {
            newOpenItems.add(id);
        }
        setOpenItems(newOpenItems);
    };

    return (
        <div className="container fade-in" style={{ maxWidth: '900px', margin: '0 auto', padding: '2rem 1rem' }}>
            <header style={{ marginBottom: '3rem', textAlign: 'center' }}>
                <h1 style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>Frequently Asked Questions</h1>
                <p style={{ fontSize: '1.25rem', color: 'var(--text-secondary)' }}>
                    Everything you need to know about mortgages and using Principal Saver
                </p>
            </header>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                {faqData.map((faq) => (
                    <div
                        key={faq.id}
                        className="card"
                        style={{
                            border: '1px solid var(--border)',
                            transition: 'all 0.2s ease',
                            cursor: 'pointer'
                        }}
                        onClick={() => toggleItem(faq.id)}
                    >
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                gap: '1rem'
                            }}
                        >
                            <h3 style={{ margin: 0, fontSize: '1.125rem', fontWeight: '600' }}>
                                {faq.question}
                            </h3>
                            {openItems.has(faq.id) ? (
                                <ChevronUp size={20} style={{ flexShrink: 0, color: 'var(--primary)' }} />
                            ) : (
                                <ChevronDown size={20} style={{ flexShrink: 0, color: 'var(--text-secondary)' }} />
                            )}
                        </div>

                        {openItems.has(faq.id) && (
                            <div
                                style={{
                                    marginTop: '1rem',
                                    paddingTop: '1rem',
                                    borderTop: '1px solid var(--border)',
                                    color: 'var(--text-secondary)',
                                    lineHeight: '1.6'
                                }}
                            >
                                {faq.answer}
                            </div>
                        )}
                    </div>
                ))}
            </div>

            <div className="card" style={{ marginTop: '3rem', backgroundColor: 'var(--primary-light)', border: 'none' }}>
                <h3 style={{ marginTop: 0, color: '#1e293b' }}>Still Have Questions?</h3>
                <p style={{ marginBottom: '1rem', color: '#475569' }}>
                    Try our calculator to explore different scenarios and see how various factors affect your mortgage.
                </p>
                <a
                    href="/"
                    className="btn btn-primary"
                    style={{ display: 'inline-block', textDecoration: 'none' }}
                >
                    Use Calculator
                </a>
            </div>
        </div>
    );
}

export default FAQ;
